// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"Content_tabsWrapper__YuzYM","tabs":"Content_tabs__1GmV2","tab":"Content_tab__G3_oQ"};